// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__28Rmx","group_item":"styles_group_item__1AOr2"};